import React from 'react';
import classnames from 'classnames';
import styles from './indicator-bar.module.scss';

const baseClass = 'indicator-bar';

export type IndicatorBarType = {
  progress: number;
  className?: string;
};

const getProgressElement = (progress: IndicatorBarType['progress']) => {
  const glowHeight = 0.16 * progress;
  const glowOffset = 0.02 * progress;

  const limitedProgress = progress < 100 ? progress : 100;

  return (
    <div
      className={styles[`${baseClass}__progress`]}
      style={{ height: `${limitedProgress}%` }}
      data-testid="indicatorbar-component"
    >
      <div
        className={styles[`${baseClass}__triangle`]}
        style={{
          bottom: `-${glowOffset}px`,
          borderLeft: '2px solid transparent',
          borderRight: '2px solid transparent',
          borderBottom: `${glowHeight}px solid rgb(215, 230, 0)`
        }}
      />
    </div>
  );
};

/**
 * @param progress  Please insert a number between 0 and 100.
 */

export const IndicatorBar = React.forwardRef<HTMLDivElement, IndicatorBarType>(({ className, progress }, ref) => {
  const classes = classnames(styles[baseClass], className);

  return (
    <div className={classes} aria-hidden={true} role="progressbar" ref={ref}>
      {getProgressElement(progress)}
    </div>
  );
});

IndicatorBar.displayName = 'IndicatorBar';
